import {
  type Alert,
  type OpportunityAlert,
  OpportunityStatusEnum,
} from "@repo/api";
import { type BadgeProps } from "@repo/skapa";
import { hasItems } from "@repo/utils";

export function getFirstUnacknowldgedAlert(alerts?: Alert[]) {
  if (!hasItems(alerts)) {
    return undefined;
  }
  return alerts
    .sort((a, b) => a.priority - b.priority)
    .find((alert) => !alert.isAcknowledged);
}

const CLOSED_OPPORTUNITY_STATUSES: OpportunityStatusEnum[] = [
  OpportunityStatusEnum.ClosedWon,
  OpportunityStatusEnum.ClosedLost,
  OpportunityStatusEnum.Invalid,
];

export function isActiveOpportunityAlert(alert: OpportunityAlert) {
  if (!alert.opportunity) {
    return false;
  }
  if (CLOSED_OPPORTUNITY_STATUSES.includes(alert.opportunity.status)) {
    return false;
  }
  return getFirstUnacknowldgedAlert(alert.alertsList) !== undefined;
}

export function getAlertColor(alertType?: Alert): BadgeProps["colour"] {
  if (alertType?.priority === 1) {
    return "red";
  } else if (alertType?.priority === 2) {
    return "orange";
  }
  return "blue";
}
